/**
 * Code for MSH Account Settings
 */
import $ from "jquery";
var accountSettingsContainer = $("#account-settings-form");
if (accountSettingsContainer && accountSettingsContainer.length > 0) {
    InitCommunityPreferenceEvents();
}
function InitCommunityPreferenceEvents() {
    // Submit Event
    var submitButton = $("#submit-account-settings");
    if (submitButton && submitButton.length > 0) {
        submitButton.on("click", function (e) {
            e.preventDefault();
            SubmitForm();
        });
    }

    // IsContractInProgress Validation
    var isContractInProgress = $("#hfIsContractInProgress").val();
    if (isContractInProgress) {
        $("#emailErrorMsg").show();
    }

    // Hide Confirmation Message
    $("#confirmation-alert").hide();
}
function SubmitForm() {
    // Reset Messages
    $("#confirmation-alert").hide();
    $("#responseErrorMsg").hide();

    var adId = $("#hfadId").val();
    var email = $("#email").val();
    var newPassword = $("#new-password").val();
    var confirmNewPassword = $("#confirm-new-password").val();
    var isSendAllEmail = $('#cbxSendAllEmail').is(':checked');
    $.ajax({
        url: '/accountsettings/save',
        data: { adID: adId, email: email, isSendAllEmail: isSendAllEmail, newPassword: newPassword, confirmNewPassword: confirmNewPassword },
        beforeSend: function () {
            window.showPreLoader();
        },
        success: function (resp) {
            if (resp) {
                if (resp.Success) {
                    if (resp.RedirectUrl.length > 0) {
                        window.location.href = resp.RedirectUrl;
                    }
                    else if (resp.HasUpdate) {
                        $("#confirmation-alert").show();
                    }
                }
                else {
                    $("#responseErrorMsg").text(resp.ErrorMessage);
                    $("#responseErrorMsg").show();
                }
            }
        },
        complete: function () {
            window.hidePreLoader();
        }
    });
}